<template>
  <!-- 微信支付弹窗 -->
  <el-dialog
    title="微信扫码支付"
    :visible.sync="centerDialogVisible"
    width="400px"
    :show-close="false"
    center
    append-to-body
    :close-on-click-modal="false"
  >
    <!-- <span>{{wxPayInfo.barcodeText}}</span> -->
    <div class="content">
      <div class="qr_text">请使用微信“扫一扫”功能扫描下方二维码进行支付</div>
      <div class="qr_text">
        本次支付金额：<span style="color: #e28a56; font-weight: 700">{{
          wxPayInfo.totalCost
        }}</span
        >元
      </div>
      <div class="qr_text">支付过程中请勿关闭或离开此页面</div>
      <div class="qr_code">
        <img :src="wxPayInfo.barcodeText" alt="" srcset="" />
      </div>
      <div class="order_pay">
        <div class="order_code">订单编号: {{ wxPayInfo.orderCode }}</div>
        <div class="order_status">
          支付状态: {{ payStatus.tradeStateDesc || "订单未支付" }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="canleOrder">取消支付</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryOrderByOutTradeNo , cancelOrder , closeByWxOutTradeNo } from "@/api/request";
export default {
  name: "",
  props: {
    wxPayInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      centerDialogVisible: true,
      getPayStatus: null,
      payStatus: {
        tradeStateDesc: "订单未支付",
      }, //订单支付状态
    };
  },
  mounted() {
    this.getPayStatus = setInterval(() => {
      queryOrderByOutTradeNo({
        orderCode: this.wxPayInfo.orderCode,
      }).then((res) => {
        this.payStatus = res.data;
        // 交易状态，枚举值：
        // SUCCESS：支付成功
        // REFUND：转入退款
        // NOTPAY：未支付
        // CLOSED：已关闭
        // REVOKED：已撤销（仅付款码支付会返回）
        // USERPAYING：用户支付中（仅付款码支付会返回）
        // PAYERROR：支付失败（仅付款码支付会返回）
        if (this.payStatus.tradeState == "SUCCESS") {
            this.$message.success("订单支付成功，请稍后");
            this.creatPay()
        }
        if (this.payStatus.tradeState == "CLOSED") {
          this.$message.error("订单已关闭");
          clearInterval(this.getPayStatus);
          //补差价不关闭订单 只关闭弹窗
          if(this.wxPayInfo.flag){
            this.$emit("closeWxPay",false);
          }else{
            if(this.wxPayInfo.orderId){
            cancelOrder({ orderId: this.wxPayInfo.orderId, cancelFlag: 1 }).then(res => {
              this.$emit("closeWxPay",true);
            })
          }else{
            this.$message.success("支付订单已被关闭，请更换支付方式或重新下单");
          }
          }
          
        }
      });
    }, 1000);
  },
  methods: {
    creatPay(){
      clearInterval(this.getPayStatus);
      this.centerDialogVisible = false
      this.$emit("creatOrder");
    },
    canleOrder() {
      clearInterval(this.getPayStatus);
      console.log(this.payStatus);
      if(this.wxPayInfo.orderCode){
          closeByWxOutTradeNo({outTradeNo: this.wxPayInfo.orderCode}).then(res => {
          this.$emit("closeWxPay",false);
        })
      }else{
        this.$message.warning("操作过快，请重试");
      }
      
    },
  },
};
</script>

<style lang='scss' scoped>
.content {
  // display: flex;
  text-align: center;
  .qr_text {
    color: #8c8c8c;
    line-height: 30px;
  }
  .order_pay {
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 12px;
  }
}
</style>